import React, { PropsWithChildren } from 'react';
import './layout.scss';
import MetaTags from 'layouts/meta-tags/meta-tags';
import GtmBody from 'components/gtm/gtm-body';

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
    const gtmKey = 'W5SNBF';

    return (
        <>
            <MetaTags gtmKey={gtmKey} />
            <main className="main">
                {children}
            </main>
            <GtmBody gtmKey={gtmKey} />
        </>
    );
};

export default Layout;
